
<template>
   {{myDate}}
</template>

<script>
import { ref ,inject} from "vue";

export default {
  props: {
    datum:{type:String},
  },
  setup(props) {
    const moment = inject("moment");

    console.log('props.datum',props.datum)
    let x=moment(props.datum).format("DD.MM.YYYY HH:mm:ss");
    const myDate = ref(x);

    

    return {
      myDate,
    };
  },        
};
</script>





